class UserPrefs {
  set(key, value) {
    localStorage.setItem(`vrpatients::prefs::${key}`, JSON.stringify(value));
  }

  get(key) {
    const preferencesJsonString = localStorage.getItem(`vrpatients::prefs::${key}`);
    let preferences = null;
    try {
      preferences = preferencesJsonString
        ? JSON.parse(preferencesJsonString)
        : null;
    } catch (e) {
      if (e.name !== 'SyntaxError') {
        throw e;
      }
    }
    return preferences;
  }

  remove(key) {
    localStorage.removeItem(`vrpatients::prefs::${key}`);
  }
}

const userPrefs = new UserPrefs();

module.exports = userPrefs;
